const DEVICE_ID_KEY = 'fanfood-device-id';

const createDeviceId = (): string => {
  const cryptoApi: any = (window as any).crypto;
  if (cryptoApi?.randomUUID) {
    return cryptoApi.randomUUID();
  }
  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
};

// Identifies this browser so orders placed from a shared POS login can be traced to the device.
export const getDeviceId = (): string => {
  let deviceId = window.localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = `web-${createDeviceId()}`;
    window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};
